<div class="content">
  <h1>{{ 'Common.Error' | translate }}</h1>
  <p>
    {{ message }}
  </p>
</div>
